import { get } from "lodash";
import React, { FC, Fragment } from "react";
import { Identifiers } from "~/constants/enum";
import useCmsBlocks from "~/hooks/useCmsBlocks";
import { styles as TextStyles } from "~/components/Text";
import { replaceClassNames } from "~/utils/converters";

interface BenefitsSectionProps {
  data?: any;
}

const BenefitsSection: FC<BenefitsSectionProps> = ({ data }) => {
  const { cmsBlocks } = useCmsBlocks([Identifiers.BenefitsSection]);
  const content = data
    ? get(data, "content", null)
    : get(cmsBlocks, [Identifiers.BenefitsSection, "content"], null);

  const compileStyle = {
    Text: TextStyles,
  };

  return content ? (
    <Fragment>
      <div
        dangerouslySetInnerHTML={{
          __html: replaceClassNames(content ?? "", compileStyle),
        }}
      />
    </Fragment>
  ) : (
    <></>
  );
};

export default BenefitsSection;
